var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{attrs:{"description":'Which language would you like to use?'}},[_c('template',{slot:"label"},[_vm._v("\n    Select language\n  ")]),_c('b-form-select',{attrs:{"options":_vm.languages},on:{"change":_vm.emitChange},model:{value:(_vm.language),callback:function ($$v) {_vm.language=$$v},expression:"language"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }